import { FC, memo } from 'react';

import EngineConfigPresenter from './EngineConfigPresenter';

const EngineConfig: FC = memo(() => (
  <EngineConfigPresenter />
));

export default EngineConfig;
